import config from '../../../../util/load-config';
import { TopBarProps } from './types';
import TopBar from './design/chunky';

const Wrapper = ({ searchIndexName, ...restProps }: TopBarProps) => {
  const searchIndex =
    searchIndexName &&
    config.algolia.apiKey &&
    config.algolia.appId &&
    searchIndexName in config.algolia.indices &&
    config.algolia.indices[searchIndexName];

  return <TopBar {...restProps} searchIndexName={searchIndex} />;
};

export default Wrapper;
